import React, { useEffect } from 'react'
import { authService } from '../../base/services'
import { track, resetUser } from 'src/main_app/mixpanel'
import { getApiUrl, getUrlParameter } from '../utils/config-utility'

// Revokes the token server side. Uses fetch (not axios) so a 401 for an
// already-expired token does not trigger the logout-on-401 redirect again.
const revokeAccessToken = () => {
  const token = authService.getAccessToken()
  if (!token) return Promise.resolve()

  return fetch(`${getApiUrl()}/auth/logout`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  }).catch(() => {})
}

const SignoutPage = (props) => {
  useEffect(() => {
    // Track before signout() clears localStorage, otherwise the user and tenant
    // this event belongs to are already gone. The event is queued in Mixpanel's
    // own storage, so it survives the redirect below.
    track('Logout', {
      reason: getUrlParameter('reason', 'user_initiated'),
    })

    revokeAccessToken()
      .then(() => authService.signout())
      .then(() => {
        // New distinct_id, so the next person to log in on this browser is not
        // merged into the profile of the one who just left.
        resetUser()
        setTimeout(() => (document.location.href = '/'), 333)
      })
  }, [])

  return (
    <div>
      <h1>Signout.</h1>
      <p>You will be redirected to the home page shortly.</p>
    </div>
  )
}

export default SignoutPage
